export enum SignatureType {
  Unknown = 'Unknown',
  Drawn = 'Drawn',
  Selected = 'Selected',
  Uploaded = 'Uploaded',
}
